export default __webpack_public_path__ + "static/media/connect-dashboard.f67a723d.png";